import React from 'react';
import './App.css';
import { store } from './actions/store';
import { Provider } from 'react-redux';
import { Backdrop, CircularProgress, createTheme } from '@mui/material';
import { ThemeProvider } from '@mui/styles';
import { Switch } from 'react-router-dom';
import Routes from './Routes';
import PrivateRoute from './componenets/core/PrivateRoute';
import Main from './componenets/layout/Main';

const theme = createTheme();

function App() {
  const spinner = <Backdrop style={{
    zIndex: '9999 !important',
    color: '#fff'
  }} open={true}>
    <CircularProgress color="inherit" />
  </Backdrop>;

  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <Switch>
          <Main>
            <React.Suspense fallback={null}>
              {
                Routes.map((route) => (
                  <PrivateRoute exact path={route.path} key={route.path} component={route.component} />
                ))}
            </React.Suspense>
          </Main>
        </Switch>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
